/* eslint-disable max-len */
import React from "react"

interface Props {
  color: string
  filter?: number
}

const path =
  "M0 396.514c39.177-17.026 75.638-21.026 109.383-12 50.617 13.54 54.887 22.177 96.532 45.176 27.764 15.333 65.792 20.025 114.085 14.076V0H0v396.514z"

export default function WaveBackground({color, filter = 97}: Props) {
  return (
    <svg width="100%" filter={`brightness(${filter}%)`} fill={color} height="100%" viewBox="10 415 300 1">
      <path fill={color} d={path} />
    </svg>
  )
}
